const NAV_ENTRIES = ['About', 'Agenda', 'Speakers', 'Partners', 'FAQs'];
const REGISTRATION_CALLBACK_PARAM_KEY = 'registration_callback';
const DATE_FORMAT = 'EEE, d MMM yyyy';
const DATE_FORMAT_NO_YEAR = 'EEE, d MMM';
const ADDEVENT_EVENT_BASE_URL = 'https://www.addevent.com/event/';
export {
  NAV_ENTRIES,
  REGISTRATION_CALLBACK_PARAM_KEY,
  DATE_FORMAT,
  DATE_FORMAT_NO_YEAR,
  ADDEVENT_EVENT_BASE_URL,
};
